export default {
    toasts: {},
}
